export default "__VITE_ASSET__315be17f__"